import { formatDate } from '../../../../../utils/date';
import { nullthrows } from '../../../../../utils/invariant';
import { decimateAndFormatNumber } from '../../../../../utils/number';
import { useInvoices } from '../../../../sale/models';
import { useCreateCreditNoteCtx } from './context';
import { Invoice } from './types';
import { DelayedSpinner } from '../../../../../components/Spinner';

export interface Props {
  searchValue: string;
}

export const InvoiceSelect: React.FC<Props> = (props) => {
  const { searchValue } = props;
  const { state, dispatch } = useCreateCreditNoteCtx();
  const customer = nullthrows(state.selectedCustomer, 'No customer selected');
  const { data, isLoading } = useInvoices({
    customerId: customer.id,
    search: searchValue || undefined,
  });

  if (isLoading) {
    return <DelayedSpinner size={8} />;
  }

  // The REST list item is structurally identical to the GraphQL Invoice the
  // reducer stores (only `status` differs nominally: enum vs string union).
  const invoices = (data ?? []) as unknown as Invoice[];

  return (
    <div className="grid gap-4 lg:grid-cols-2 xl:grid-cols-3">
      {!invoices.length && <div>Geen verkopen gevonden</div>}

      {invoices.map((i) => {
        return (
          <div
            key={i.id}
            className="card p-4"
            data-clickable="true"
            onClick={() => {
              dispatch({
                type: 'SELECT_INVOICE',
                invoice: i,
              });
            }}
          >
            <div className="flex justify-between">
              <div className="card-heading-text">{i.invoiceNumber}</div>
              <div className="card-subtle-text">{formatDate(i.date)}</div>
            </div>

            <div className="mt-4">{`Verzonden op: ${i.sentAt ? formatDate(i.sentAt) : '-'}`}</div>
            <div>{`Betaald op: ${i.paidAt ? formatDate(i.paidAt) : '-'}`}</div>
            <div>{`Totaal: € ${decimateAndFormatNumber(i.totalInclVat, 2, {
              decimalSeperator: ',',
            })}`}</div>
          </div>
        );
      })}
    </div>
  );
};
